import { getNotificationTypeSortOrder } from '../types/notification-type';
export const sortNotifications = (notifications) => {
    return [...notifications].sort(compareNotification);
};
export const compareNotification = (a, b) => {
    const sortOrderResult = getNotificationTypeSortOrder(a.type) - getNotificationTypeSortOrder(b.type);
    const displayPriorityResult = a.displayPriority - b.displayPriority;
    return sortOrderResult || displayPriorityResult;
};
